import React, { useEffect, useState, useRef } from 'react';
import house from "../assets/house.webp";
import slide1 from "../assets/lodge6.avif";
import slide2 from "../assets/lodge2.jpeg";
import slide3 from "../assets/lodge4.jpg";
import slide4 from "../assets/ROOM-OF-4-B-1.webp";
import slide5 from "../assets/lodge5.jpg";
import img6 from "../assets/ROOM-OF-3-B.jpeg";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from "../assets/logo.jpg" 
import CampusApp from "../assets/CampusApp.jpg"
import Budget from "../assets/Budget.jpg"
import TimeRenter from "../assets/TimeRenter.jpg"
import * as THREE from 'three';

// Component to handle the 3D background animation
const AnimatedBackground = () => {
    // A ref to attach the Three.js renderer to the DOM
    const mountRef = useRef(null);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        // Scene setup
        const scene = new THREE.Scene();
        // Camera setup - controls what the user sees
        const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
        camera.position.z = 5;

        // Renderer setup - draws the scene on the canvas
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setSize(window.innerWidth, window.innerHeight);
        
        // Ensure mountRef.current exists before appending
        if (mountRef.current) {
            mountRef.current.appendChild(renderer.domElement);
        }

        // Add ambient light to the scene
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        scene.add(ambientLight);

        // Add a point light to create highlights and shadows
        const pointLight = new THREE.PointLight(0xffffff, 1);
        pointLight.position.set(5, 5, 5);
        scene.add(pointLight);

        // Array to hold animated shapes
        const shapes = [];
        const shapeGeometries = [
            new THREE.TorusGeometry(1, 0.4, 16, 100),
            new THREE.SphereGeometry(1, 32, 32),
            new THREE.BoxGeometry(1.5, 1.5, 1.5)
        ];
        const shapeMaterials = [
            new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 100 }),
            new THREE.MeshPhongMaterial({ color: 0xcccccc, shininess: 100 }),
            new THREE.MeshPhongMaterial({ color: 0x8a2be2, shininess: 100 })
        ];

        // Create and position multiple shapes
        for (let i = 0; i < 15; i++) {
            const geometry = shapeGeometries[Math.floor(Math.random() * shapeGeometries.length)];
            const material = shapeMaterials[Math.floor(Math.random() * shapeMaterials.length)];
            const shape = new THREE.Mesh(geometry, material);
            
            // Randomly position shapes within a certain range
            shape.position.set(
                (Math.random() - 0.5) * 20,
                (Math.random() - 0.5) * 20,
                (Math.random() - 0.5) * 20
            );
            
            // Randomly scale the shapes
            const scale = Math.random() * 0.5 + 0.5;
            shape.scale.set(scale, scale, scale);
            
            shapes.push(shape);
            scene.add(shape);
        }

        // Animation loop
        const animate = () => {
            requestAnimationFrame(animate);

            // Animate each shape
            shapes.forEach(shape => {
                shape.rotation.x += 0.001;
                shape.rotation.y += 0.002;
                shape.position.y += Math.sin(Date.now() * 0.0005) * 0.001;
            });

            renderer.render(scene, camera);
        };

        // Handle window resizing
        const handleResize = () => {
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(window.innerWidth, window.innerHeight);
        };
        
        window.addEventListener('resize', handleResize);

        // Start the animation
        animate();

        // Cleanup function for when the component unmounts
        return () => {
            if (isMounted && mountRef.current && renderer.domElement) {
                mountRef.current.removeChild(renderer.domElement);
            }
            window.removeEventListener('resize', handleResize);
        };
    }, [isMounted]);

    return <div ref={mountRef} className="absolute inset-0 z-0 opacity-20" />;
};

const CampusKeys = () => {
   const slides = [slide1, slide2, slide3, slide4, slide5];
    const [currentSlide, setCurrentSlide] = useState(0);

    const cardVariants = {
      hidden: { opacity: 0, y: 30 },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6,
          ease: "easeOut"
        }
      }
    };

    const phrases = [
      "Find your next room on",
      "List your self contain on",
      "Live smarter with",
    ];

    const [text, setText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);
    const [phraseIndex, setPhraseIndex] = useState(0);
    const [typingSpeed, setTypingSpeed] = useState(500);

    useEffect(() => {
      const currentPhrase = phrases[phraseIndex];

      if (isDeleting) {
        setTypingSpeed(100);
        setText((prev) => prev.slice(0, prev.length - 1));
      } else {
        setTypingSpeed(200);
        setText((prev) => currentPhrase.slice(0, prev.length + 1));
      }

      if (!isDeleting && text === currentPhrase) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && text === "") {
        setIsDeleting(false);
        setPhraseIndex((prev) => (prev + 1) % phrases.length);
      }

      const timer = setTimeout(() => {}, typingSpeed);
      return () => clearTimeout(timer);
    }, [text, isDeleting, phraseIndex, typingSpeed, phrases]);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 4000);
      return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <div className="bg-[#0d2f24] text-white font-inter relative min-h-screen">
            <AnimatedBackground />
            
            {/* HERO SECTION */}
            <motion.section 
                className="relative py-16 px-4 sm:px-6 md:px-10 lg:px-16 overflow-hidden z-10"
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
            >
                {/* Background Overlay */}
                <div className="absolute inset-0 bg-black/50 backdrop-blur-sm z-0" />
                {/* Floating Emojis */}
                <div className="absolute text-2xl animate-pulse z-10">
                    <div className="absolute top-6 left-6 sm:top-10 sm:left-10">🎓</div>
                    <div className="absolute top-1/3 right-6 sm:right-10">🏠</div>
                    <div className="absolute bottom-16 left-1/4">📚</div>
                    <div className="absolute bottom-6 right-1/3">🏫</div>
                </div>
                {/* Content Container */}
                <div className="relative z-10 max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center gap-10">
                    {/* Text Content */}
                    <motion.div className="text-center lg:text-left w-full lg:w-1/2 px-2">
                        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-gold bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400 font-playfair">
                            {text} <br /> campus keys
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl text-white/80 font-playfair mb-8">
                            Discover verified off-campus housing near UNN. Simple, fast, and secure.
                        </p>
                        {/* CTA Buttons */}
                        <div className="flex flex-col sm:flex-row sm:justify-center lg:justify-start items-center gap-4">
                            <Link 
                                to="/listing" 
                                className="bg-yellow-500 text-[#0d2f24] px-8 py-4 rounded-full font-bold shadow-lg hover:bg-yellow-600 transition-colors"
                            >
                                Browse Listings
                            </Link>
                            <Link 
                                to="/AddProperty" 
                                className="border border-yellow-500 text-yellow-500 px-8 py-4 rounded-full font-bold hover:bg-yellow-500 hover:text-[#0d2f24] transition-colors"
                            >
                                List Your Property
                            </Link>
                        </div>
                    </motion.div>
                    {/* Image Section */}
                    <motion.div className="w-full lg:w-1/2 px-2" variants={cardVariants}>
                        <img 
                            src={house} 
                            alt="Off-campus housing" 
                            className="rounded-3xl shadow-xl w-full h-auto object-cover max-h-[500px]"
                        />
                    </motion.div>
                </div>
            </motion.section>

            {/* ABOUT SECTION */}
            <motion.section 
                className="container px-6 py-16 mx-auto text-white" 
                id="about"
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
            >
                <div className="lg:flex items-center gap-12">
                    <motion.div className="lg:w-1/2 space-y-6" variants={cardVariants}>
                        <h3 className="text-4xl md:text-5xl font-bold leading-tight">
                            We build for <span className="text-gold z-50 bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400 font-playfair">Students</span>, Landlords & Agents
                        </h3>
                        <p className="text-white/80 text-lg">
                            From quick property uploads to verified listings, CampusKeys helps you connect with the right buyers and renters—right on campus.
                        </p>
                    </motion.div>
                    <motion.div className="mt-12 lg:mt-0 lg:w-1/2 relative group" variants={cardVariants}>
                        <img
                            className="object-cover w-full rounded-3xl h-96 transition-transform duration-500 group-hover:scale-105"
                            src={ logo }
                            alt="Student housing"
                        />
                        <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-[#0d2f24]/40 to-transparent rounded-3xl transition-transform duration-500 group-hover:scale-105"></div>
                    </motion.div>
                </div>
            </motion.section>

            {/* FEATURES SECTION */}
            <motion.section 
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                className="container px-6 py-8 mx-auto lg:py-16"
            >
                <div className="grid grid-cols-1 gap-8 xl:gap-12 md:grid-cols-2 xl:grid-cols-3">
                    {[
                        {
                            title: "Affordable Rooms",
                            desc: "Find clean and affordable student rooms close to campus, with flexible lease options.",
                            icon: (
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h1l1 9h14l1-9h1M4 10l1-6h14l1 6M10 21v-5h4v5" />
                              </svg>
                            )
                        },
                        {
                            title: "Verified Listings",
                            desc: "All apartments are verified by our team to ensure safety, quality, and accuracy.",
                            icon: (
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                            )
                        },
                        {
                            title: "Easy Booking",
                            desc: "Reserve your next room online with just a few clicks — fast, secure, and stress-free.",
                            icon: (
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                              </svg>
                            )
                        }
                    ].map((item, i) => (
                        <motion.div key={i} className="p-8 space-y-4 border border-gold rounded-3xl backdrop-blur-sm hover:scale-105 transition-transform duration-300" custom={i} variants={cardVariants}>
                            {item.icon}
                            <h1 className="text-2xl font-semibold text-white capitalize">{item.title}</h1>
                            <p className="text-white/80">{item.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </motion.section>
 
            {/* GALLERY SECTION */}
            <section className="container px-6 py-8 mx-auto lg:py-16">
                <h3 className="text-2xl font-bold text-white md:text-3xl lg:text-4xl">Our Gallery</h3>
                <div className="grid grid-cols-1 gap-10 mt-10 md:grid-cols-2 lg:grid-cols-3">
                    <a href="#" className="transition-all duration-500 lg:col-span-2 hover:scale-105 rounded-3xl overflow-hidden shadow-2xl">
                        <img className="object-cover object-top w-full h-80 xl:h-96" src={img6} alt=""/>
                    </a>
                    <a href="#" className="transition-all duration-500 hover:scale-105 rounded-3xl overflow-hidden shadow-2xl">
                        <img className="object-cover object-top w-full h-80 xl:h-96" src={slide5} alt=""/>
                    </a>
                    <a href="#" className="transition-all duration-500 hover:scale-105 rounded-3xl overflow-hidden shadow-2xl">
                        <img className="object-cover object-top w-full h-80 xl:h-96" src={slide4} alt=""/>
                    </a>
                    <a href="#" className="transition-all duration-500 lg:col-span-2 hover:scale-105 rounded-3xl overflow-hidden shadow-2xl">
                        <img className="object-cover object-top w-full h-80 xl:h-96" src={slide3} alt=""/>
                    </a>
                    <a href="#" className="transition-all duration-500 lg:col-span-2 hover:scale-105 rounded-3xl overflow-hidden shadow-2xl">
                        <img className="object-cover object-top w-full h-80 xl:h-96" src={slide2} alt=""/>
                    </a>
                    <a href="#" className="transition-all duration-500 hover:scale-105 rounded-3xl overflow-hidden shadow-2xl">
                        <img className="object-cover object-top w-full h-80 xl:h-96" src={slide1} alt=""/>
                    </a>
                </div>
            </section>

            {/* INSIGHTS SECTION */}
            <motion.section
                className="container px-6 py-8 mx-auto lg:py-16"
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
            >
                <h3 className="text-2xl font-bold text-white md:text-3xl lg:text-4xl">
                    Latest Insights on Campus Living
                </h3>
                <div className="grid grid-cols-1 gap-8 mt-8 md:mt-10 md:grid-cols-2 xl:grid-cols-3">
                    {[
                        {
                            img: CampusApp,
                            author: "Tom Hank",
                            role: "Housing Consultant",
                            title: "How to Choose the Right Campus Apartment",
                            desc: "Learn how to evaluate apartment listings, check amenities, and make the smartest housing choice as a student.",
                        },
                        {
                            img: Budget,
                            author: "Arthur Melo",
                            role: "Student Blogger",
                            title: "Budgeting for Off-Campus Living",
                            desc: "A practical guide to managing rent, utilities, and daily expenses while living in a student apartment.",
                        },
                        {
                            img: TimeRenter,
                            author: "Amelia Anderson",
                            role: "Senior Resident",
                            title: "Top 5 Tips for First-Time Renters",
                            desc: "From signing leases to inspecting the property — everything new renters should know before moving in.",
                        },
                    ].map((item, i) => (
                        <motion.div
                            key={i}
                            custom={i}
                            variants={cardVariants}
                            className="bg-transparent"
                        >
                            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                                <img
                                    className="object-cover object-center w-full h-64 rounded-3xl lg:h-80 transition-transform duration-500 hover:scale-105"
                                    src={item.img}
                                    alt=""
                                />
                            </div>
                            <div className="p-4 bg-gray-800/50 backdrop-blur-sm rounded-3xl -mt-10 relative z-10 shadow-lg mx-2">
                                <h1 className="mt-2 text-xl font-semibold text-white">
                                    {item.title}
                                </h1>
                                <hr className="w-16 my-4 border-yellow-400" />
                                <p className="text-sm text-white/80">
                                    {item.desc}
                                </p>
                                <a
                                    href="#"
                                    className="inline-block mt-4 text-yellow-400 underline hover:text-yellow-300"
                                >
                                    Read more
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </motion.section>
        </div>
    );
};

export default CampusKeys;
